export default __webpack_public_path__ + "static/media/email_icon.6a62c705.svg";